import { useEffect, useRef, useState } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { useIsDesktop } from '@/hooks/use-user-platform';
import type { IncomingContextMenuPrompt, Prompt } from '@/stores/prompter';

interface Props {
  prompt: Prompt & IncomingContextMenuPrompt;
}

export default function ContextMenuPrompt({ prompt }: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isDesktop = useIsDesktop();
  const [position, setPosition] = useState<[number, number] | null>(null);

  useEffect(() => {
    if (!wrapperRef.current) return;

    let [posX, posY] = prompt.meta?.position ?? [0, 0];
    const wrapperRect = wrapperRef.current.getBoundingClientRect();

    if (posX + wrapperRect.width > window.innerWidth) {
      posX = window.innerWidth - wrapperRect.width - 15;
    }
    if (posY + wrapperRect.height > window.innerHeight) {
      posY = window.innerHeight - wrapperRect.height - 15;
    }

    setPosition([posX, posY]);
  }, [prompt]);

  useOnClickOutside(wrapperRef, () => {
    prompt.resolvers.resolve(false);
  });

  return (
    <div className='fixed inset-0 z-90 backdrop-blur desktop:backdrop-blur-none'>
      <div
        ref={wrapperRef}
        className='absolute z-100 top-1/2 -translate-y-1/2 left-5'
        style={
          isDesktop
            ? {
                left: position?.[0] ?? 0,
                top: position?.[1] ?? 0,
              }
            : {}
        }>
        {prompt.content(prompt.resolvers)}
      </div>
    </div>
  );
}
